import { instructionStageContent } from './instruction-stages';

const stage = instructionStageContent;

export const en = {
  translation: {
    meta: {
      title: 'Maze Navigation',
      description: 'A flame-guided maze navigation game.',
    },
    auth: {
      failed: 'Could not start session',
      failedTitle: 'Failed to authenticate',
    },
    instructions: {
      primaryCtaLabel: 'Play Now',
      secondaryCtaLabel: 'Learn How To Play?',
      stages: {
        '1': stage,
        '2': stage,
        '3': stage,
        '4': stage,
      },
    },
    results: {
      success: {
        scoreLabel: 'YOUR SCORE',
        chipLabel: "You're Doing Awesome",
        headingLeading: "Well done! You've completed the",
        headingHighlight: ' stage',
        headingTrailing: '',
        subheading: 'Keep it up for the upcoming games.',
        progressLabel: 'Progress',
        progressSuffixLabel: 'Games completed',
        ctaLabel: 'Continue',
      },
      failure: {
        scoreLabel: 'YOUR SCORE',
        chipLabel: 'You gave it a try!',
        headingLeading: "Don't worry, try again in the",
        headingHighlight: ' next game!',
        headingTrailing: '',
        subheading: "Keep practicing, you'll get there!",
        progressLabel: 'Progress',
        progressSuffixLabel: 'Games completed',
        ctaLabel: 'Continue',
      },
      exitCloseTabHint: 'You can now close this tab safely.',
      exitUseAppBackHint: 'You can now go back to the app.',
    },
    hud: {
      done: 'Done',
      skipLevel: 'Skip',
      settings: 'Settings',
      closeSettings: 'Close settings',
      openSettings: 'Open settings',
      soundEffects: 'Sound Effects',
      soundOn: 'On',
      soundOff: 'Off',
      controls: 'Controls',
      controlsOn: 'On',
      controlsOff: 'Off',
      startFresh: 'Start Fresh',
      testing: 'Testing',
      returnHome: 'Return to home',
      level: 'Level',
      levelCompleted: 'Level Completed',
      mode: 'Mode',
      demo: 'Demo',
      preview: 'Preview',
      time: 'Time',
      disableAnimations: 'Disable Animations',
    },
    controls: {
      hint: 'Find Your Way — Swipe or Use WASD / Arrow Keys',
    },
    tutorial: {
      tapToContinue: 'Tap to continue',
      steps: {
        ball: 'Your Ball',
        controls: 'Arrow Controls',
        path: 'Path to Portal',
        zoom: 'Use Pinch / Mouse Wheel to Zoom',
      },
    },
    app: {
      tiltDetected: 'Tilt detected!',
      switchToPortrait: 'Switch to portrait mode to keep playing',
    },
    offline: {
      connectionLost: 'Connection Lost',
      youAreOffline: 'You are offline',
      message: 'Internet is required to continue. Please check your network and retry.',
      retry: 'Retry',
    },
    common: {
      loading: 'Loading...',
    },
    loading: {
      game: 'Loading game',
    },
    demo: {
      noLevelsAdded: 'No DEMO levels added',
    },
    toast: {
      secondShort: 'sec',
      secondsShort: 'secs',
      demoCompleteTitle: 'Demo Cleared',
      demoCompleteDescription: 'Auto redirecting to the homepage in {seconds} {secondLabel}',
      previewCompleteTitle: 'Preview Complete',
      previewCompleteDescription: 'Preview level completed... redirecting...',
      redirectDestinationShort: 'the homepage',
    },
    win: {
      mazeCleared: 'Maze Cleared!',
      levelComplete: 'Level Complete',
    },
  },
};
